import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { RDDarkService } from '../../dark.service';

@Component({
  selector: 'rd-panel',
  template: `<div class="panel {{color}}Panel" [class.open]="open" [class.rdDark]="dark">
  <div class="panelTitle" (click)="changeState()">
    <ng-content select="[title]"></ng-content>

    <span class="openIcon">
        <span *ngIf="open"><i class="fas fa-chevron-up"></i></span>
        <span *ngIf="!open"><i class="fas fa-chevron-down"></i></span>
      </span>
  </div>
  <div class="textContainer" #textContainer>
    <div class="content" #textContent>
      <ng-content></ng-content>
    </div>
  </div>
</div>
`,
  styles: [`.panel{--main-color:black;--background-color:transparent;--text-color:black;width:100%;box-shadow:0 1px 2px rgba(0,0,0,.16);padding:6px;box-sizing:border-box;color:var(--text-color);background-color:var(--background-color);transition:all .3s linear}.panel.open{box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);margin:12px 0}.panel.open .panelTitle{padding-bottom:6px}.panel .panelTitle{display:flex;justify-content:space-between;color:var(--main-color);cursor:pointer;font-size:17px}.panel .panelTitle .openIcon{padding-right:6px}.panel .textContainer{overflow:hidden;transition:height .2s ease-in;height:0;padding-right:30px}.panel.goldPanel{--main-color:#ba9e5a}.panel.greenPanel{--main-color:#72ba5a}.panel.bluePanel{--main-color:#5a5aba}.panel.blue-lightPanel{--main-color:#5aa2ba}.panel.redPanel{--main-color:#ba5a5a}.panel.purplePanel{--main-color:#a25aba}.panel.orangePanel{--main-color:#ba8a5a}.panel.rdDark{--text-color:white;--background-color:#07384c}`]
})
export class RDPanelComponent implements OnInit {

  @Input() color = 'black';

  @Output() stateChange = new EventEmitter<any>();

  @ViewChild('textContainer') textContainer;
  @ViewChild('textContent') textContent;

  open = false;
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  changeState() {
    this.open = !this.open;
    this.stateChange.emit(this.open);
    this.changeTextContainerSize();
  }

  changeTextContainerSize() {
    if (this.open) {
      this.textContainer.nativeElement.style.height = this.textContent.nativeElement.clientHeight + 'px';
    } else {
      this.textContainer.nativeElement.style.height = '0px';
    }
  }

}
